import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {CrudUtilities} from '../util/crud-utilities';
import {BehaviorSubject} from 'rxjs';
import {ArticlesModel} from '../models/articles.model';

@Injectable()
export class CmsService {

  public technicalDescriptionContentSubject = new BehaviorSubject<string>('');
  public technicalDescriptionContent = this.technicalDescriptionContentSubject.asObservable();

  public generalInformationContentSubject = new BehaviorSubject<string>('');
  public generalInformationContent = this.generalInformationContentSubject .asObservable();

  constructor(private apiService: ApiService, public crudUtils: CrudUtilities) {
  }

  saveTechnicalDescriptionContent(content){
    return this.apiService.patch('/technicalDescription.json', {content: content});
  }

  getTechnicalDescriptionContent(){
    return this.apiService.get('/technicalDescription.json').subscribe((response)=>{
      this.technicalDescriptionContentSubject.next(response.content);
    });
  }

  savePartnersContent(content){
    return this.apiService.patch('/partnersPage.json', {content: content});
  }

  getPartnersContent(){
    return this.apiService.get('/partnersPage.json');
  }

  saveGeneralInformationContent(content){
    return this.apiService.patch('/generalInformation.json', {content: content});
  }

  getGeneralInformationContent(){
    return this.apiService.get('/generalInformation.json').subscribe((response)=>{
      this.generalInformationContentSubject.next(response.content);
    });
  }




}
